import { convertMonthNumberToText } from '@/utils/dates';

const BirthdateMonthOptions = [...Array(12).keys()].map((i) => ({
  value: i + 1,
  text: convertMonthNumberToText(i + 1),
}));

export default BirthdateMonthOptions;
